module.exports = __webpack_public_path__ + "static/media/top-hero-academia@2x.fb290053.jpg";